import type { IEventBus } from "@/domains/events"

import type { SwapAggregatorDAO } from "./types"
import { SwapAggregatorStore } from "./swap-aggregator-store"

export class SwapAggregatorFactory {
  static createStore(aggregatorData: SwapAggregatorDAO, eventBus?: IEventBus): SwapAggregatorStore {
    return new SwapAggregatorStore(aggregatorData, eventBus)
  }
}
